import { NavbarWidgetStyled } from './styled';
import { AvatarNavWidget } from 'widgets';

const NavbarWidget = ({ collapsed, onToggleCollapse }) => {
  return (
    <NavbarWidgetStyled>
      <button
        type="button"
        className="nav_collapse_btn"
        onClick={onToggleCollapse}
        aria-label={collapsed ? 'ขยายเมนู' : 'ย่อเมนู'}
        title={collapsed ? 'ขยายเมนู' : 'ย่อเมนู'}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>
      <div className="nav_user_infomation">
        <AvatarNavWidget />
      </div>
    </NavbarWidgetStyled>
  );
};

export default NavbarWidget;
